import { render, staticRenderFns } from "./WhatsNextSection.vue?vue&type=template&id=6530dbcd&scoped=true"
import script from "./WhatsNextSection.vue?vue&type=script&lang=js"
export * from "./WhatsNextSection.vue?vue&type=script&lang=js"
import style0 from "./WhatsNextSection.vue?vue&type=style&index=0&id=6530dbcd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6530dbcd",
  null
  
)

export default component.exports